<template>
	<div class="print-container">
		<auth-container :page="$parent.page">
			<print-menu></print-menu>

			<div class="d-flex mb-4">
				<h2 class="mr-2">Flood Control O&amp;M Program<br />Reimbursement Request {{$parent.item.reimbursementNumber}}</h2>
				<div class="ml-auto text-right">
					<img :src="`${publicPath}images/logos/tsswcb-logo.svg`" alt="TSSWCB Logo" class="img-fluid" style="width:170px">
				</div>
			</div>

			<b-row>
				<b-col md="7">
					<b-table-simple small class="table-definitions border-bottom">
						<b-tbody>
							<b-tr>
								<b-th>Proposal</b-th>
								<b-td>
									<span v-if="$parent.proposal !== null">{{$parent.proposal.proposalNumber}}</span>
									<span v-else>N/A</span>
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>Sponsor</b-th>
								<b-td>
									{{$parent.sponsor.type}} {{$parent.sponsor.id}} - {{$parent.sponsor.name}}
								</b-td>
							</b-tr>
							<b-tr>
								<b-th>Notes</b-th>
								<b-td>{{valueOrNa($parent.item.notes, 'None')}}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
				<b-col md>
					<b-table-simple small class="table-definitions border-bottom">
						<b-tbody>
							<b-tr>
								<b-th>Received</b-th>
								<b-td>{{$parent.item.dateReceived | date}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Recorded</b-th>
								<b-td>{{$parent.item.dateRecorded | date('ddd, MMM D, YYYY', 'None')}}</b-td>
							</b-tr>
							<b-tr>
								<b-th>Invoiced</b-th>
								<b-td>{{$parent.item.invoiceDate | date('ddd, MMM D, YYYY', 'None')}}</b-td>
							</b-tr>
						</b-tbody>
					</b-table-simple>
				</b-col>
			</b-row>

			<h3 class="mt-3">Practices</h3>
			<b-table striped responsive small show-empty :fields="activities.fields" :items="$parent.activities.items" no-local-sorting style="font-size:0.8rem">
				<template #cell(dam)="data">
					{{data.value.name}}
				</template>
				<template #cell(practice)="data">
					{{data.value.name}}
				</template>
				<template #cell(unitsPerformed)="data">
					{{data.value | number(2)}} {{data.item.units}}
				</template>
				<template #empty>
					<p class="my-2">This proposal does not have any practices entered.</p>
				</template>

				<template #custom-foot>
					<b-tr class="bg-light border-bottom font-weight-bold">
						<b-td colspan="4">Total</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'invoicedAmount') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'stateAmount') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'requiredMatch') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'inkindMatchDeduction') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'totalOmPaid') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'stateAdminPayment') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'totalPaid') | number(2)}}</b-td>
						<b-td class="text-right">${{ sum($parent.activities.items, 'reappropriated') | number(2)}}</b-td>
					</b-tr>
				</template>
			</b-table>
		</auth-container>
	</div>
</template>

<script>
	import PrintMenu from '@/components/helpers/PrintMenu';

	export default {
		name: 'ReimbursementPrint',
		components: { PrintMenu },
		data() {
			return {
				activities: {
					fields: [
						{ key: 'dam', label: 'Dam', sortable: false },
						{ key: 'practice', label: 'Practice', sortable: false },
						{ key: 'unitsPerformed', label: 'Units', sortable: false, class: 'text-right', formatter: (value) => { return this.numberFormat(value, 2); } },
						{ key: 'unitCost', label: 'Unit Cost', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'invoicedAmount', label: 'Invoiced', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'stateAmount', label: 'State 90%', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'requiredMatch', label: 'Req. Match', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						//{ key: 'isInkindMatch', label: 'In-Kind Match?', sortable: false, class: 'text-center', formatter: (value) => { return value ? '✔' : '-'; } },
						{ key: 'inkindMatchDeduction', label: 'In-Kind', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						//{ key: 'remainingRequiredMatch', label: 'Remaining Match Req.', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'totalOmPaid', label: 'O&M Paid', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'stateAdminPayment', label: 'Admin. Paid', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'totalPaid', label: 'Total Paid', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } },
						{ key: 'reappropriated', label: 'Reapp.', sortable: false, class: 'text-right', formatter: (value) => { return this.money(value); } }
					]
				}
			}
		}
	}
</script>